// Import bootstrap
import * as bootstrap from 'bootstrap'

// Import our SCSS
import '../scss/main.scss'

// Your custom JavaScript here

// Update URL hash when a Bootstrap tab is activated
document.addEventListener('DOMContentLoaded', function () {
	const tabLinks = document.querySelectorAll('a[data-bs-toggle="tab"]');
	// Activate tab from hash on page load
	if (window.location.hash) {
		const hash = window.location.hash.replace('#', '');
		const tabToShow = document.getElementById(hash);
		if (tabToShow && tabToShow.getAttribute('data-bs-toggle') === 'tab') {
			const tabInstance = bootstrap.Tab.getOrCreateInstance(tabToShow);
			tabInstance.show();
		}
	}

	tabLinks.forEach(function (tab) {
		tab.addEventListener('shown.bs.tab', function (event) {
			if (event.target && event.target.id) {
				// Update the hash in the URL bar
				history.replaceState(null, '', '#' + event.target.id);
			}
		});
	});
});